<template>
  <v-list id="chat-message-list">
    <v-progress-circular v-if="isLoading" indeterminate color="primary" />

    <LazyList
      :items="messages"
      @load-more="loadMoreData"
      :has-more-data="hasMoreData"
    >
      <template v-slot:default="{ items }">
        <v-list-item v-for="message in items" :key="message.id">
          <template v-if="user.id == message.user?.id">
            <MessageContent
              :message="message"
              :isUserLogged="user.id == message.user?.id"
            />
            <v-list-item-avatar>
              <img
                v-if="message.user_photo"
                :src="message.user_photo"
                :alt="message.user_name"
              />
              <div
                v-else
                class="initial-letter-username"
                :style="{ ...initialLetterStyleById(message.user.id) }"
              >
                {{ formatUserNameFirstLetter(message) }}
              </div>
            </v-list-item-avatar>
          </template>
          <template v-else>
            <v-list-item-avatar>
              <img
                v-if="message.user_photo"
                :src="message.user_photo"
                :alt="message.user_name"
              />
              <div
                v-else
                class="initial-letter-username"
                :style="{ ...initialLetterStyleById(message.user.id) }"
              >
                {{ formatUserNameFirstLetter(message) }}
              </div>
            </v-list-item-avatar>
            <MessageContent
              :message="message"
              :isUserLogged="user.id == message.user?.id"
            />
          </template>
        </v-list-item>
      </template>
    </LazyList>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';

import ServiceChatAPI from '@/services/api/serviceChat';
import MessageContent from '@/components/ServiceOrder/Chat/MessageContent';

import LazyList from '@/components/Common/LazyList';

export default {
  components: {
    MessageContent,
    LazyList,
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      itemsPerPage: 10,
      hasMoreData: false,
      colors: [
        '#f44336',
        '#e91e63',
        '#9c27b0',
        '#673ab7',
        '#3f51b5',
        '#2196f3',
        '#03a9f4',
        '#00bcd4',
        '#009688',
        '#4caf50',
        '#8bc34a',
        '#cddc39',
        '#ffeb3b',
        '#ffc107',
        '#ff9800',
        '#ff5722',
        '#795548',
        '#9e9e9e',
        '#607d8b',
      ],
      messages: [],
      messageFetchInterval: null,
    };
  },
  props: {
    serviceOrderId: Number,
    addedMessage: Boolean,
  },
  watch: {
    addedMessage(newVal) {
      if (newVal) {
        this.search();
      }
    },
  },
  computed: {
    ...mapGetters('Auth', ['user']),
  },
  methods: {
    formatUserNameFirstLetter(message) {
      return (message.user_name || '?').charAt(0).toUpperCase();
    },
    initialLetterStyleById(id) {
      return {
        backgroundColor: this.randomColorById(id),
        color: 'white',
      };
    },
    randomColorById(id) {
      return this.colors[id % this.colors.length];
    },
    async search() {
      this.isLoading = true;

      try {
        const response = await ServiceChatAPI.search(this.serviceOrderId, {
          page: this.currentPage,
          size: this.itemsPerPage,
        });

        this.processApiResponse(response.data);
      } catch (error) {
        console.error('Search error:', error);

        this.$toast.error('Erro ao buscar mensagens do chat');
      } finally {
        this.isLoading = false;
      }
    },
    processApiResponse(data) {
      if (!data) return;

      const { rows = [], currentPage = 1, totalPages = 1 } = data;

      const newMessages = rows.filter(
        (message) => !this.messages.some((existingMessage) => existingMessage.id === message.id)
      );

      this.messages = [...newMessages, ...this.messages].sort(
        (a, b) => a.id - b.id,
      );

      this.currentPage = currentPage;
      this.hasMoreData = this.currentPage < totalPages;
    },
    loadMoreData() {
      if (this.hasMoreData && !this.isLoading) {
        this.currentPage += 1;
        this.search();
      }
    },
  },
  mounted() {
    this.messageFetchInterval = setInterval(this.search, 10000);
    this.search();
  },
  beforeDestroy() {
    clearInterval(this.messageFetchInterval);
  },
};
</script>

<style lang="scss" scoped>
#chat-message-list {
  padding: 0;
  max-height: 100%;
  overflow-y: auto;
  background: transparent !important;

  .v-progress-circular {
    width: 100% !important;
    position: absolute;
    z-index: 1;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.5s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }

  .v-list-item {
    margin-top: 16px;
    margin-bottom: 16px;

    .initial-letter-username {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
